export var hasTimestamps = function () { return ({
    timeCreated: '',
    timeUpdated: '',
    timeDeleted: '',
}); };
